export var SELECTION_TOOLBAR_LABEL = 'Selection toolbar';
export var DEFAULT_POPUP_SELECTORS = {
  toolbarContainer: '[role="toolbar"]',
  portal: '.atlaskit-portal'
};